module.exports = __webpack_public_path__ + "img/2005.5ad739f8.jpg";